// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ProgressDisplay {
  padding: 2em;
}
.CSVImporter_ProgressDisplay__status {
  text-align: center;
  font-size: 1.15em;
  color: #202020;
}
.CSVImporter_ProgressDisplay__status.-pending {
  color: #808080;
}
.CSVImporter_ProgressDisplay__count {
  text-align: right;
  font-size: 1em;
  color: #808080;
}
.CSVImporter_ProgressDisplay__count > var {
  display: inline-block;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}
.CSVImporter_ProgressDisplay__progressBar {
  position: relative;
  width: 100%;
  height: 0.5em;
  background: #f0f0f0;
}
.CSVImporter_ProgressDisplay__progressBarIndicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background: #202020;
  transition: width 0.2s ease-out;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/ProgressDisplay.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;AAGE;EACE,kBAAA;EACA,iBCKY;EDJZ,cAAA;AADJ;AAGI;EACE,cCFe;ADCrB;AAKE;EACE,iBAAA;EACA,cAAA;EACA,cCTiB;ADMrB;AAKI;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAHN;AAOE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBChCQ;AD2BZ;AAQE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,mBClCQ;EDoCR,+BAAA;AAPJ","sourcesContent":["@import '../../theme.scss';\n\n.CSVImporter_ProgressDisplay {\n  padding: 2em;\n\n  &__status {\n    text-align: center;\n    font-size: $titleFontSize;\n    color: $textColor;\n\n    &.-pending {\n      color: $textSecondaryColor;\n    }\n  }\n\n  &__count {\n    text-align: right;\n    font-size: 1em;\n    color: $textSecondaryColor;\n\n    > var {\n      display: inline-block;\n      width: 1px;\n      height: 1px;\n      overflow: hidden;\n      opacity: 0;\n    }\n  }\n\n  &__progressBar {\n    position: relative; // for indicator\n    width: 100%;\n    height: 0.5em;\n    background: $fillColor;\n  }\n\n  &__progressBarIndicator {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0; // dynamically set in code\n    height: 100%;\n    background: $textColor;\n\n    transition: width 0.2s ease-out;\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
